// Thema's (feat/themas), zie themesApp.nl.ts.
export const appThemesAr = {
    audience: 'سمة هذه اللوحة',
    audienceHint: 'يمكنك تغييره لاحقًا في الأجهزة اللوحية، أو على اللوحة نفسها عبر تعديل (ولكل شاشة أيضًا).',
    adult: 'العائلة والكبار',
    adultHint: 'مظهر الكبار: هادئ وبسيط، ألوان محايدة ورموز خطية.',
    kids: 'الأطفال',
    kidsHint: 'مظهر الأطفال: رموز ملوّنة وأزرار ونصوص أكبر. إذا كانت اللوحة في غرفة الأطفال، فإنها تعرض أشياءهم فقط.',
    pictos: 'الرموز في التطبيق',
    pictosHint: 'ينطبق على هذا الجهاز.',
    pictosClean: 'بسيط (خطوط هادئة)',
    pictosColor: 'مرح (ملوّن)',
};
//# sourceMappingURL=themesApp.ar.js.map